import { $Values } from 'utility-types';
import {
    COMPLETE_ACCOUNT_SUCCESS,
    COMPLETE_COMPLETE_ACCOUNT_MODAL,
    COMPLETE_FOLLOW_SEARCH_MODAL,
    COMPLETE_LOGIN_MODAL,
    COMPLETE_SEND_SELLER_MESSAGE_MODAL,
    COMPLETE_SIGN_UP_MODAL,
    DISMISS_MODAL,
    LOGIN_SUCCESS,
    OPEN_ABSENTEE_BID_MODAL,
    OPEN_ABSENTEE_BID_MODAL_ACTION,
    OPEN_ADD_CREDIT_CARD_MODAL,
    OPEN_ADD_SEARCH_ALERT_MODAL,
    OPEN_BID_LIMIT_EXCEEDED_MODAL,
    OPEN_BUY_NOW_MODAL,
    OPEN_CATALOG_ANNOUNCEMENT_MODAL,
    OPEN_CHANGE_PASSWORD_MODAL,
    OPEN_CLASSIC_BIDDING_CONSOLE_MODAL,
    OPEN_CLEAR_CACHE_MODAL,
    OPEN_COMPLETE_ACCOUNT_MODAL,
    OPEN_CONFIRM_PASSWORD_MODAL,
    OPEN_CONFIRM_UNFOLLOW_SEARCH_MODAL,
    OPEN_CONSIGNMENT_CONFIRM_MODAL,
    OPEN_DELETE_ACCOUNT_CONFIRMATION_MODAL,
    OPEN_DESCRIPTION_MODAL,
    OPEN_DOWNLOAD_MOBILE_MODAL,
    OPEN_EXCLUDE_HOUSE_MODAL,
    OPEN_FEEDBACK_MODAL,
    OPEN_FORGOT_PASSWORD_MODAL,
    OPEN_HEALTHCHECK_MODAL,
    OPEN_INSTALL_FLASH_MODAL,
    OPEN_LIVE_BID_MODAL,
    OPEN_LOGIN_MODAL,
    OPEN_MODAL,
    OPEN_ON_THE_HUNT_MODAL,
    OPEN_REGISTER_FOR_CATALOG_MODAL,
    OPEN_REPORT_REVIEW_MODAL,
    OPEN_RETRACT_BID_MODAL,
    OPEN_REVIEWS_MODAL,
    OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL,
    OPEN_SEND_SELLER_MESSAGE_MODAL,
    OPEN_SET_PASSWORD_MODAL,
    OPEN_SHIPPING_AND_PAYMENT_MODAL,
    OPEN_SIGN_UP_MODAL,
    OPEN_SMS_CONFIRMATION_MODAL,
    OPEN_TAX_EXEMPT_MODAL,
    OPEN_WAITING_FOR_APPROVAL_MODAL,
    SET_LOGIN_SIGNUP_TYPE,
} from './actions';
import { CREATE_ACCOUNT_SUCCESS } from './createAccount';
import { createSelector } from '@reduxjs/toolkit';
import { fetchSellersIfNeeded } from '@/redux/modules/seller';
import { FORGOT_PASSWORD_FAIL } from './forgotPassword';
import { GlobalState } from '../rootReducer';
import { modalTypes, PaymentProviders } from '@/enums';
import {
    OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER,
    OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER,
    OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER,
    OPEN_LOGIN_MODAL_FROM_CHECKER,
    OPEN_SET_PASSWORD_MODAL_FROM_CHECKER,
    OPEN_SIGN_UP_MODAL_FROM_CHECKER,
} from './shouldLogin';

export type LoginSignupTypes =
    | 'default'
    | 'see sold price'
    | 'follow auctioneer'
    | 'register for auction'
    | 'register for auction - item'
    | 'save item'
    | 'place bid'
    | 'ask a question - auctioneer'
    | 'ask a question - item'
    | 'follow search';

export type ModalContext = {
    id: number;
    type: LoginSignupTypes;
};

export type State = {
    addCreditCardModalProvider: PaymentProviders;
    addressId: number;
    alertTypeId: number;
    data: any;
    excludeIsInclude: boolean;
    excludeSellerId: number;
    isAddCreditCardBiddingConsole: boolean;
    isInstantAutopay: boolean;
    modal: $Values<typeof modalTypes>;
    modalContext: ModalContext;
    savedSearchId: number;
    searchParams: any;
    signupFromFlattenTheCurvePage: boolean;
    signupModalSeller: number;
    signupReferralHouse: number;
};

// reducer
export const DEFAULT_STATE: State = {
    addCreditCardModalProvider: PaymentProviders.Payrix,
    addressId: 0,
    alertTypeId: null,
    data: null,
    excludeIsInclude: false,
    excludeSellerId: 0,
    isAddCreditCardBiddingConsole: false,
    isInstantAutopay: false,
    modal: modalTypes.NONE,
    modalContext: null,
    savedSearchId: 0,
    searchParams: null,
    signupFromFlattenTheCurvePage: false,
    signupModalSeller: 0,
    signupReferralHouse: 0,
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}): State {
    switch (action.type) {
        case COMPLETE_ACCOUNT_SUCCESS:
        case COMPLETE_COMPLETE_ACCOUNT_MODAL:
        case COMPLETE_SEND_SELLER_MESSAGE_MODAL:
        case CREATE_ACCOUNT_SUCCESS:
        case LOGIN_SUCCESS:
            return {
                ...state,
                modal: modalTypes.NONE,
            };
        case DISMISS_MODAL:
            return {
                ...state,
                data: null,
                isAddCreditCardBiddingConsole: false,
                isInstantAutopay: false,
                modal: modalTypes.NONE,
                modalContext: { id: 0, type: 'default' },
            };
        case OPEN_ADD_SEARCH_ALERT_MODAL:
            return {
                ...state,
                modal: modalTypes.ADD_SEARCH_ALERT,
            };
        case OPEN_ADD_CREDIT_CARD_MODAL:
            return {
                ...state,
                addCreditCardModalProvider: action.payload.addCreditCardModalProvider || PaymentProviders.Payrix,
                isAddCreditCardBiddingConsole: action.payload.isAddCreditCardBiddingConsole,
                isInstantAutopay: action.payload.isInstantAutopay,
                modal: modalTypes.ADD_CREDIT_CARD,
            };
        case OPEN_ABSENTEE_BID_MODAL:
            return {
                ...state,
                isInstantAutopay: action.payload.isInstantAutopay,
                modal: modalTypes.ABSENTEE_BID,
            };
        case OPEN_BID_LIMIT_EXCEEDED_MODAL:
            return {
                ...state,
                modal: modalTypes.BID_LIMIT_EXCEEDED,
            };
        case OPEN_BUY_NOW_MODAL:
            return {
                ...state,
                modal: modalTypes.BUY_NOW,
            };
        case OPEN_CATALOG_ANNOUNCEMENT_MODAL:
            return {
                ...state,
                modal: modalTypes.CATALOG_ANNOUNCEMENT,
            };
        case OPEN_CLASSIC_BIDDING_CONSOLE_MODAL:
            return {
                ...state,
                modal: modalTypes.CLASSIC_BIDDING_CONSOLE,
            };
        case OPEN_COMPLETE_ACCOUNT_MODAL:
        case OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.COMPLETE_ACCOUNT,
            };
        case OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.FOLLOW_SEARCH,
                searchParams: action.searchParams,
            };
        case OPEN_SHIPPING_AND_PAYMENT_MODAL:
            return {
                ...state,
                modal: modalTypes.SHIPPING_AND_PAYMENT,
            };
        case OPEN_SIGN_UP_MODAL:
        case OPEN_SIGN_UP_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.SIGN_UP,
                signupFromFlattenTheCurvePage: action?.payload?.fromFlattenTheCurvePage ?? false,
                signupReferralHouse: action?.payload?.sellerId ?? 0,
            };
        case OPEN_SMS_CONFIRMATION_MODAL:
            return {
                ...state,
                alertTypeId: action?.payload,
                modal: modalTypes.SMS_CONFIRMATION,
            };
        case OPEN_DELETE_ACCOUNT_CONFIRMATION_MODAL:
            return {
                ...state,
                modal: modalTypes.DELETE_ACCOUNT_CONFIRMATION,
            };
        case OPEN_DESCRIPTION_MODAL:
            return {
                ...state,
                modal: modalTypes.DESCRIPTION,
            };
        case OPEN_DOWNLOAD_MOBILE_MODAL:
            return {
                ...state,
                modal: modalTypes.DOWNLOAD_MOBILE,
            };
        case OPEN_HEALTHCHECK_MODAL:
            return {
                ...state,
                modal: modalTypes.HEALTHCHECK,
            };
        case OPEN_INSTALL_FLASH_MODAL:
            return {
                ...state,
                modal: modalTypes.INSTALL_FLASH,
            };
        case OPEN_ON_THE_HUNT_MODAL:
            return {
                ...state,
                modal: modalTypes.ON_THE_HUNT,
            };
        case OPEN_WAITING_FOR_APPROVAL_MODAL:
            return {
                ...state,
                modal: modalTypes.WAITING_FOR_APPROVAL,
            };
        case OPEN_CHANGE_PASSWORD_MODAL:
            return {
                ...state,
                modal: modalTypes.CHANGE_PASSWORD,
            };
        case OPEN_CONFIRM_PASSWORD_MODAL:
        case OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.CONFIRM_PASSWORD,
            };
        case OPEN_CONSIGNMENT_CONFIRM_MODAL:
            return {
                ...state,
                modal: modalTypes.CONFIRM_CONSIGNMENT,
            };
        case FORGOT_PASSWORD_FAIL:
        case OPEN_FORGOT_PASSWORD_MODAL:
            return {
                ...state,
                modal: modalTypes.FORGOT_PASSWORD,
            };
        case OPEN_FEEDBACK_MODAL:
            return {
                ...state,
                modal: modalTypes.FEEDBACK,
            };
        case OPEN_LIVE_BID_MODAL:
            return {
                ...state,
                modal: modalTypes.LIVE_BID,
            };
        case OPEN_LOGIN_MODAL:
        case OPEN_LOGIN_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.LOGIN,
            };
        case OPEN_REPORT_REVIEW_MODAL:
            return {
                ...state,
                modal: modalTypes.REPORT_REVIEW,
            };
        case OPEN_RETRACT_BID_MODAL:
            return {
                ...state,
                modal: modalTypes.RETRACT_BID,
            };
        case OPEN_REVIEWS_MODAL:
            return {
                ...state,
                modal: modalTypes.REVIEWS,
            };
        case OPEN_REGISTER_FOR_CATALOG_MODAL:
            return {
                ...state,
                isInstantAutopay: action.payload.isInstantAutopay,
                modal: modalTypes.REGISTER_FOR_AUCTION,
            };
        case OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL:
            return {
                ...state,
                modal: modalTypes.SEND_SELLER_CONSIGNMENT_MESSAGE,
            };
        case OPEN_SEND_SELLER_MESSAGE_MODAL:
            return {
                ...state,
                modal: modalTypes.SEND_SELLER_MESSAGE,
            };
        case OPEN_SET_PASSWORD_MODAL:
        case OPEN_SET_PASSWORD_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.SET_PASSWORD,
            };
        case OPEN_TAX_EXEMPT_MODAL:
            return {
                ...state,
                modal: modalTypes.TAX_EXEMPT,
            };
        case OPEN_EXCLUDE_HOUSE_MODAL:
            return {
                ...state,
                excludeIsInclude: action?.payload?.isInclude,
                excludeSellerId: action?.payload?.sellerId,
                modal: modalTypes.EXCLUDE_HOUSE,
            };
        case OPEN_CONFIRM_UNFOLLOW_SEARCH_MODAL:
            return {
                ...state,
                modal: modalTypes.CONFIRM_UNFOLLOW_SEARCH,
                savedSearchId: action?.payload?.savedSearchId,
            };
        case SET_LOGIN_SIGNUP_TYPE:
            return {
                ...state,
                modalContext: action?.payload,
            };
        case OPEN_CLEAR_CACHE_MODAL:
            return {
                ...state,
                modal: modalTypes.CLEAR_CACHE,
            };
        case OPEN_MODAL:
            return {
                ...state,
                data: action.payload.data,
                modal: action.payload.modalType,
            };
        case modalTypes.BID_CONSOLE_EXPLAINER:
            return {
                ...state,
                modal: modalTypes.BID_CONSOLE_EXPLAINER,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const modalSelector = (state: GlobalState) => state.modal;
export const getInstantAutopay = createSelector(modalSelector, (modal) => modal.isInstantAutopay);

export const getOpenModal = createSelector(modalSelector, (modal) => modal.modal || modalTypes.NONE);
export const getOpenModalData = createSelector(modalSelector, (modal) => modal.data);

export const getAddCreditCardModalProvider = createSelector(modalSelector, (state) => state.addCreditCardModalProvider);
export const getIsAddCreditCardBiddingConsole = createSelector(
    modalSelector,
    (state) => state.isAddCreditCardBiddingConsole
);
export const getSearchParams = createSelector(modalSelector, (state) => state.searchParams);
export const getSignupReferralHouse = createSelector(modalSelector, (state) => state.signupReferralHouse);
export const getAddressID = createSelector(modalSelector, (state) => state.addressId);
export const getSignupFromFlattenTheCurvePage = createSelector(
    modalSelector,
    (state) => state.signupFromFlattenTheCurvePage
);
export const getAlertTypeId = createSelector(modalSelector, (state) => state.alertTypeId);

export const getExcludeModalSellerId = createSelector(modalSelector, (state) => state.excludeSellerId);
export const getExcludeIsInclude = createSelector(modalSelector, (state) => state.excludeIsInclude);

export const getConfirmUnfollowSearchId = createSelector(modalSelector, (state) => state.savedSearchId);

export const getModalContext: (state: GlobalState) => ModalContext = createSelector(
    modalSelector,
    (state) => state.modalContext || { id: 0, type: 'default' }
);

/* ACTION CREATORS */
export const completeLoginModal = () => ({
    type: COMPLETE_LOGIN_MODAL,
});

export const completeSendSellerMessageModal = () => ({
    type: COMPLETE_SEND_SELLER_MESSAGE_MODAL,
});

export const completeSignUpModal = () => ({
    type: COMPLETE_SIGN_UP_MODAL,
});

export const completeFollowSearchModal = () => ({
    type: COMPLETE_FOLLOW_SEARCH_MODAL,
});

export const dismissModal = () => ({
    type: DISMISS_MODAL,
});

export const openAbsenteeBidModal = (itemId: number, bidAmount?: number, isInstantAutopay?: boolean) =>
    ({
        payload: { bidAmount, isInstantAutopay, itemId },
        type: OPEN_ABSENTEE_BID_MODAL,
    } as OPEN_ABSENTEE_BID_MODAL_ACTION);

export const openAddCreditCardModal = (
    addCreditCardModalProvider: number,
    isAddCreditCardBiddingConsole: boolean = false,
    isInstantAutopay: boolean = false
) => ({
    payload: { addCreditCardModalProvider, isAddCreditCardBiddingConsole, isInstantAutopay },
    type: OPEN_ADD_CREDIT_CARD_MODAL,
});

export const openAddressModal = (data) => ({
    payload: {
        data: data,
        modalType: modalTypes.ADDRESS,
    },
    type: OPEN_MODAL,
});

export const openAddSearchAlertModal = () => ({
    type: OPEN_ADD_SEARCH_ALERT_MODAL,
});

export const openBidLimitExceededModal = (catalogId: number) => ({
    payload: catalogId,
    type: OPEN_BID_LIMIT_EXCEEDED_MODAL,
});

export const openBuyNowModal = ({ itemId, modalType, offerPrice }: any) => ({
    payload: { itemId, modalType, offerPrice },
    type: OPEN_BUY_NOW_MODAL,
});

export const openChangePasswordModal = () => ({
    type: OPEN_CHANGE_PASSWORD_MODAL,
});

export const openCompleteAccountModal = () => ({
    type: OPEN_COMPLETE_ACCOUNT_MODAL,
});

export const openConfirmPasswordModal = (payload: any) => ({
    payload,
    type: OPEN_CONFIRM_PASSWORD_MODAL,
});

export const openConfirmConsignmentModal = () => ({
    type: OPEN_CONSIGNMENT_CONFIRM_MODAL,
});

export const openDownloadMobileModal = () => ({
    type: OPEN_DOWNLOAD_MOBILE_MODAL,
});

export const openFeedbackModal = () => ({
    type: OPEN_FEEDBACK_MODAL,
});

export const openForgotPasswordModal = () => ({
    type: OPEN_FORGOT_PASSWORD_MODAL,
});

export const openHealthcheckModal = () => ({
    type: OPEN_HEALTHCHECK_MODAL,
});

export const openLoginModal = () => ({
    type: OPEN_LOGIN_MODAL,
});

export const openOnTheHuntModal = () => ({
    type: OPEN_ON_THE_HUNT_MODAL,
});

export const openExcludeHouseModal = (sellerId: number, isInclude?: boolean) => async (dispatch: Function) => {
    await dispatch(fetchSellersIfNeeded([sellerId]));
    dispatch({
        payload: { isInclude, sellerId },
        type: OPEN_EXCLUDE_HOUSE_MODAL,
    });
};

export const openClearCacheModal = () => ({
    type: OPEN_CLEAR_CACHE_MODAL,
});

type OpenRegisterForAuctionModalParams = {
    catalogId: number;
    fromBiddingConsole?: boolean;
    isInstantAutopay?: boolean;
    itemId?: number;
};
export const openRegisterForAuctionModal = ({
    catalogId,
    fromBiddingConsole = false,
    isInstantAutopay = false,
    itemId = 0,
}: OpenRegisterForAuctionModalParams) => ({
    payload: { catalogId, fromBiddingConsole, isInstantAutopay, itemId },
    type: OPEN_REGISTER_FOR_CATALOG_MODAL,
});

export const openRetractBidModal = (itemId: number) => ({
    payload: { itemId },
    type: OPEN_RETRACT_BID_MODAL,
});

export const openSendSellerConsignmentMessageModal = (messageDetails: any, sellerId: number, sellerName: string) => ({
    payload: { messageDetails, sellerId, sellerName },
    type: OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL,
});

export const openSendSellerMessageModal = (
    messageDetails: any,
    sellerId: number,
    sellerName: string,
    subject: string,
    title: string = ''
) => ({
    payload: { messageDetails, sellerId, sellerName, subject, title },
    type: OPEN_SEND_SELLER_MESSAGE_MODAL,
});

export const openSetPasswordModal = () => ({
    type: OPEN_SET_PASSWORD_MODAL,
});

export const openShippingAndPaymentModal = () => ({
    type: OPEN_SHIPPING_AND_PAYMENT_MODAL,
});

export const openCatalogAnnouncementModal = (catalogId: number) => ({
    payload: { catalogId },
    type: OPEN_CATALOG_ANNOUNCEMENT_MODAL,
});

export const openSignUpModal = (sellerId?: number, fromFlattenTheCurvePage?: boolean) => {
    const action: any = {
        type: OPEN_SIGN_UP_MODAL,
    };
    if (sellerId || fromFlattenTheCurvePage) {
        action.payload = {
            fromFlattenTheCurvePage: Boolean(fromFlattenTheCurvePage),
            sellerId,
        };
    }
    return action;
};

export const openWaitingForApprovalModal = (catalogId: number, hideUrgentMessages: boolean = false) => {
    return {
        payload: { catalogId, hideUrgentMessages },
        type: OPEN_WAITING_FOR_APPROVAL_MODAL,
    };
};

export const openReportReviewModal = (reviewId: number) => ({
    payload: reviewId,
    type: OPEN_REPORT_REVIEW_MODAL,
});

export const openReviewsModal = (sellerId: number) => ({
    payload: sellerId,
    type: OPEN_REVIEWS_MODAL,
});

export const openSMSConfirmationModal = (alertTypeId: number) => ({
    payload: alertTypeId,
    type: OPEN_SMS_CONFIRMATION_MODAL,
});

export const openDeleteAccountConfirmationModal = () => ({
    type: OPEN_DELETE_ACCOUNT_CONFIRMATION_MODAL,
});

export const openTaxExemptModal = () => ({
    type: OPEN_TAX_EXEMPT_MODAL,
});

export const openAddressVerifyModal = (data) => ({
    payload: {
        data: data,
        modalType: modalTypes.ADDRESS_VERIFY_MODAL,
    },
    type: OPEN_MODAL,
});

export const setModalContext = ({ id, type }: ModalContext) => {
    return {
        payload: { id, type },
        type: SET_LOGIN_SIGNUP_TYPE,
    };
};

export const openZipModal = () => ({
    payload: { modalType: modalTypes.ZIP_INFO_MODAL },
    type: OPEN_MODAL,
});

export const openConfirmUnfollowSearchModal = (savedSearchId: number) => ({
    payload: { modalType: modalTypes.CONFIRM_UNFOLLOW_SEARCH, savedSearchId },
    type: OPEN_CONFIRM_UNFOLLOW_SEARCH_MODAL,
});

export const openBidConsoleExplainerModal = () => ({
    type: modalTypes.BID_CONSOLE_EXPLAINER,
});
